export const kenhBan = {
  nhom: {
    BAN_OFF: 'Bán offline',
    BAN_ON: 'Bán online',
  },
  labels: {
    TU_GIAO: 'Tự giao',
    VAN_CHUYEN_THU_3: 'VC thứ 3',
    SHOPEE: 'Shopee',
    TIKTOK_SHOP: 'TikTok',
    LAZADA: 'Lazada',
    FACEBOOK_ZALO: 'Facebook / Zalo',
    WEBSITE: 'Website',
  },
}
